import App from 'app'
import { TextEditor } from 'components/input'
import React, { useEffect, useState } from 'react'
import Select from "react-select"
import { GetUser } from 'services/Session'
import { GetSetting, SetSetting } from 'services/Setting'

export function configForm(props) {
	const user = GetUser()
	const [errorMessage, setErrorMessage] = useState('')
	const [loading, setLoading] = useState(false)
	const [setting, setSetting] = useState({
		"address": '',
		"description": '',
		"courier.code": '',
		"facebook_url": '',
		"instagram_url": '',
		"whatsapp_url": '',
		"instagram_post_url": '',
		"about": '',
		"terms": '',
		"privacy": '',
	})

	function setData(key, value) {
		if (setting[key] !== value) {
			setSetting({ ...setting, [key]: value })
		}
	}

	useEffect(() => {
		const getData = async () => {
			await GetSetting(setSetting)
		}
		getData()
	}, [])

	const inputClass = [
		'bg-gray-50',
		'block',
		'border',
		'border-gray-300',
		'p-2.5',
		'rounded-md',
		'w-full',
		'dark:bg-gray-700',
		'dark:border-gray-600',
		'dark:focus:border-sky-500',
		'dark:focus:ring-sky-500',
		'dark:placeholder-gray-400',
		'dark:text-white',
		'focus:border-sky-500',
		'focus:ring-sky-500',
	].join(' ')

	const options = [
		{value: 'pos', label: 'POS Indonesia'},
		{value: 'lion', label: 'Lion Parcel'},
		{value: 'ninja', label: 'Ninja Xpress'},
		{value: 'sicepat', label: 'SiCepat'},
		{value: 'jne', label: 'JNE'},
		{value: 'tiki', label: 'TIKI'},
		{value: 'rpx', label: 'RPX Holding'},
		{value: 'wahana', label: 'Wahana'},
		{value: 'pandu', label: 'Pandu Logistics'},
		{value: 'ide', label: 'ID Express'},
		{value: 'sap', label: 'SAP Express'},
		{value: 'ncs', label: 'NCS'},
		{value: 'anteraja', label: 'AnterAja'},
		{value: 'rex', label: 'Royal Express Indonesia'},
		{value: 'jtl', label: 'JTL Express'},
		{value: 'sentral', label: 'Sentral Cargo'},
		{value: 'jnt', label: 'J&T Express'},
		{value: 'pahala', label: 'Pahala Kencana Express'},
		{value: 'slis', label: 'Solusi Ekspres'},
		{value: 'expedito', label: 'Expedito*'},
		{value: 'ray', label: 'Rayspeed*'},
		{value: 'dse', label: '21 Express'},
		{value: 'first', label: 'First Logistics'},
		{value: 'star', label: 'Star Cargo'},
		{value: 'idl', label: 'IDL Cargo'},
	]

	const handleSubmit = async (e) => {
		setLoading(true)
		e.preventDefault()
		try {
			const res = await SetSetting(setting)
			alert(res?.data?.message?? 'Pengaturan web berhasil diperbarui.')
		} catch (e) {
			setErrorMessage(e?.response?.data?.error?.message?? 'Gagal terhubung ke server, silakan coba lagi nanti.')
			setTimeout(() => {
				setErrorMessage('')
			}, 3000)
		}
		setLoading(false)
	}

	return (
		<App user={user} setting={setting}>
			<div className='p-4'>
				{errorMessage && (
					<div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-6 py-3 rounded-md shadow-md flex items-center" style={{zIndex: 9999}}>
						<span>{errorMessage}</span>
						<button className="ml-4 text-white focus:outline-none" onClick={() => setErrorMessage('')}>✖</button>
					</div>
				)}
				<div className="mx-auto mt-10 p-4 bg-white rounded-lg shadow-md w-full md:w-3/4">
					<h3 className="font-bold leading-tight tracking-tight text-center mb-4">
						Pengaturan Web
					</h3>
					<form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" action="#">
						<div>
							<label className="block mb-2 font-medium dark:text-white">Ekspedisi</label>
							<Select 
								placeholder="Pilih ekspedisi..."
								isMulti
								value={setting['courier.code'].split(',').map(value => { return options.find(option => option.value === value) })} 
								onChange={(values) => { setData('courier.code', values ? values.map(val => val.value).join(',') : '') }} 
								options={options}
								styles={{
								control: (baseStyles, _state) => ({
									...baseStyles,
									backgroundColor: 'rgb(249 250 251 / 1)',
									padding: 2,
									borderColor: 'rgba(var(--bs-gray-300-rgb), 1) !important',
									borderRadius: '0.375rem',
								}),
								}}
							/>
						</div>
						<div>
							<label htmlFor="facebook_url" className="block mb-2 font-medium dark:text-white">Facebook URL</label>
							<input onChange={(e) => setData('facebook_url', e.target.value)} value={setting?.facebook_url}  name="facebook_url" id="facebook_url" className={inputClass}/>
						</div>
						<div>
							<label htmlFor="instagram_url" className="block mb-2 font-medium dark:text-white">Instagram URL</label>
							<input onChange={(e) => setData('instagram_url', e.target.value)} value={setting?.instagram_url}  name="instagram_url" id="instagram_url" className={inputClass}/>
						</div>
						<div>
							<label htmlFor="whatsapp_url" className="block mb-2 font-medium dark:text-white">WhatsApp URL</label>
							<input onChange={(e) => setData('whatsapp_url', e.target.value)} value={setting?.whatsapp_url}  name="whatsapp_url" id="whatsapp_url" className={inputClass}/>
						</div>
						<div>
							<label htmlFor="instagram_post_url" className="block mb-2 font-medium dark:text-white">Instagram Post URL</label>
							<input onChange={(e) => setData('instagram_post_url', e.target.value)} value={setting?.instagram_post_url}  name="instagram_post_url" id="instagram_post_url" className={inputClass}/>
						</div>
						<div>
							<label htmlFor="description" className="block mb-2 font-medium dark:text-white">Deskripsi</label>
							<TextEditor text={setting?.description} setText={(val) => setData('description', val)} name="description" id="description" className={inputClass} />
						</div>
						<div>
							<label htmlFor="address" className="block mb-2 font-medium dark:text-white">Alamat</label>
							<TextEditor text={setting?.address} setText={(val) => setData('address', val)} name="address" id="address" className={inputClass} />
						</div>
						<div>
							<label htmlFor="about" className="block mb-2 font-medium dark:text-white">Tentang Kami</label>
							<TextEditor text={setting?.about} setText={(val) => setData('about', val)} name="about" id="about" className={inputClass} />
						</div>
						<div>
							<label htmlFor="terms" className="block mb-2 font-medium dark:text-white">Syarat & Ketentuan</label>
							<TextEditor text={setting?.terms} setText={(val) => setData('terms', val)} name="terms" id="terms" className={inputClass} />
						</div>
						<div>
							<label htmlFor="privacy" className="block mb-2 font-medium dark:text-white">Kebijakan Privasi</label>
							<TextEditor text={setting?.privacy} setText={(val) => setData('privacy', val)} name="privacy" id="privacy" className={inputClass} />
						</div>
						<div className="grid gap-4 grid-flow-col justify-end">
							<button onClick={() => setView('view-profile')} type="button" className="px-4 py-2.5 text-gray-800 bg-gray-200 rounded-md hover:bg-gray-400">Batal</button>
							<button type="submit" className="text-white bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md px-4 py-2.5 text-center dark:bg-sky-500 dark:hover:bg-sky-700 dark:focus:ring-blue-800">
								{loading ? (
									<svg className="w-4 h-4 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
										<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
										<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
									</svg>
								) : (
									"Simpan"
								)}
							</button>
						</div>
					</form>
				</div>
			</div>
		</App>
	)
}
